<div class="logo-container" [ngClass]="{'disable': isDisable}" [attr.data-logo]="logo"
  [style.background-color]="backgroundColor" [style.height]="height" [style.width]="width"
  *ngIf="!loading">
  <!-- using circle width for height as well to maintain same ratio -->
  <div class="status-circle" [style.height]="statusCircleWidth" [style.width]="statusCircleWidth"
    [style.background-color]="statusCircleColor">
    <div *ngIf="statusCircleIcon !== 'none'" ngbTooltip="{{toolTipMsg}}" placement="top"
      container="body" class="status-marker" tooltipClass="{{toolTipClass}}" cygovSvgIcon
      [svgName]="statusCircleIcon"></div>
  </div>

  <!-- <div class="flip-card">
    <div class="flip-card-inner">
      <div class="flip-card-front">
        
      </div>
      <div class="flip-card-back">
        <span class="integration-name">{{ integrationName }}</span>
      </div>
    </div>
  </div> -->

  <div *ngIf="isSVG" class="logo" cygovSvgIcon [svgName]="logo"></div>
  <img *ngIf="!isSVG" [src]="'assets/images/' + logo" />
  <div *ngIf="showAllBadge" class="all-badge-wrapper">
    <img src="assets/svg/live-stamp.svg" class="all-badge-bg" />
    <span class="all-badge-text lato-14-n-vw">ALL</span>
  </div>
  <div *ngIf="inProgress" class="in-progress-overlay">
    <div class="spinner"></div>
  </div>
</div>